import React from 'react';

import { CreditAgreement, Util } from '@finley-technologies/finley-types';

import { LenderOrgProvidedInputView } from './LenderOrgProvidedInputView';
import { LenderPrincipalBalanceDailyAverageView } from './LenderPrincipalBalanceDailyAverageView';
import { LenderPrincipalBalancePointInTimeView } from './LenderPrincipalBalancePointInTimeView';
import { LenderTAccountsSumView } from './LenderTAccountsSumView';
import { WipConfig } from 'packages/creditAgreements/ui/types';

type LenderPostgresQueryViewProps = {
  postgresQuery: CreditAgreement.Config.PortfolioCovenant.PostgresQuery.Query;
  wipConfig?: WipConfig;
  fullPropertyKey: string;
  duplicateParams: {
    isDuplicateQueryOpen: boolean;
    onDuplicateQueryOpen: () => void;
    onDuplicateQueryClose: () => void;
    duplicateQuery: (params: { queryKeyInput: string }) => Promise<void>;
    isDuplicateLoading: boolean;
  };
  deleteParams: {
    isDeleteConfirmationModalOpen: boolean;
    onDeleteConfirmationModalOpen: () => void;
    onDeleteConfirmationModalClose: () => void;
    deleteQuery: () => Promise<void>;
    isDeleteLoading: boolean;
  };
  onSave: (
    query: CreditAgreement.Config.PortfolioCovenant.PostgresQuery.Query,
  ) => Promise<void>;
  isSaveLoading: boolean;
  presetVariables: CreditAgreement.Config.QueryVariable[];
  inputDateType: 'reportingDate' | 'triggerDate';
  triggerDate?: Util.FullDateStr;
};
export const LenderPostgresQueryView = ({
  postgresQuery,
  wipConfig,
  fullPropertyKey,
  duplicateParams,
  deleteParams,
  onSave,
  isSaveLoading,
  presetVariables,
  inputDateType,
  triggerDate,
}: LenderPostgresQueryViewProps) => {
  switch (postgresQuery.type) {
    case 'principalBalanceDailyAverage':
      return (
        <LenderPrincipalBalanceDailyAverageView
          postgresQuery={postgresQuery}
          wipConfig={wipConfig}
          fullPropertyKey={fullPropertyKey}
          duplicateParams={duplicateParams}
          deleteParams={deleteParams}
          onSave={onSave}
          isSaveLoading={isSaveLoading}
          triggerDate={triggerDate}
          inputDateType={inputDateType}
          presetVariables={presetVariables}
        />
      );
    case 'principalBalancePointInTime':
      return (
        <LenderPrincipalBalancePointInTimeView
          postgresQuery={postgresQuery}
          wipConfig={wipConfig}
          fullPropertyKey={fullPropertyKey}
          duplicateParams={duplicateParams}
          deleteParams={deleteParams}
          onSave={onSave}
          isSaveLoading={isSaveLoading}
          triggerDate={triggerDate}
          inputDateType={inputDateType}
          presetVariables={presetVariables}
        />
      );
    case 'tAccountsSum':
      return (
        <LenderTAccountsSumView
          postgresQuery={postgresQuery}
          wipConfig={wipConfig}
          fullPropertyKey={fullPropertyKey}
          duplicateParams={duplicateParams}
          deleteParams={deleteParams}
          onSave={onSave}
          isSaveLoading={isSaveLoading}
          triggerDate={triggerDate}
          inputDateType={inputDateType}
          presetVariables={presetVariables}
        />
      );
    case 'orgProvidedInput':
      return (
        <LenderOrgProvidedInputView
          postgresQuery={postgresQuery}
          wipConfig={wipConfig}
          fullPropertyKey={fullPropertyKey}
          duplicateParams={duplicateParams}
          deleteParams={deleteParams}
          onSave={onSave}
          isSaveLoading={isSaveLoading}
          triggerDate={triggerDate}
          inputDateType={inputDateType}
          presetVariables={presetVariables}
        />
      );
    default:
      return null;
  }
};
